export const maxRowIndex = 10;
export const minTileIndex = -5;
export const maxTileIndex = 5;
export const tilesPerRow = maxTileIndex - minTileIndex + 1;
export const tileSize = 42;
export const maxLayerDepth = 11;
